import { useContext, useEffect, useMemo, useState } from "react";
import services from "../../services/services";
import { callautopopulate } from "../../services/callautopop";
import { encryptData } from "../../utils/encrypt";
import { useLocation } from "react-router-dom";
import { ToastContext } from "../../context/ToastContext";
import { Urls } from "../../services/Urls";

export const useResetPassword = () => {
    const { showSuccess, showError } = useContext(ToastContext);
    const [resetPasswordData, setResetPasswordData] = useState({
        old_password: "",
        new_password: "",
        conform_password: "",
        email_or_employeecode: ""
    });
    const [showPassword, setShowPassword] = useState({
        old_password: false,
        new_password: false,
        conform_password: false
    });
    const [error, setError] = useState({});
    const location = useLocation().state

    useEffect(() => {
        if (location) {
            setResetPasswordData({ ...resetPasswordData, email_or_employeecode: location });
        } else {
            callautopopulate("user_info").then(async res => {
                setResetPasswordData({ ...resetPasswordData, email_or_employeecode: res?.user_info?.[0]?.email_id });
            })
        }
    }, [])

    // Handle input values
    const handleChange = (e) => {
        const { name, value } = e.target;
        setResetPasswordData({ ...resetPasswordData, [name]: value });
        setError({ ...error, [name]: '' })
    };

    // Validate new password
    const validateNewPassword = (password) => {
        const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;
        return passwordPattern.test(password);
    };

    // handle reset password
    const HandleResetPassword = async (e) => {
        const error = {}
        e.preventDefault();
        const { old_password, new_password, conform_password } = resetPasswordData;
        if (!old_password?.trim()) {
            error.old_password = "Old password is required.";
        }
        if (!new_password?.trim()) {
            error.new_password = "New password is required.";
        }
        if (!conform_password?.trim()) {
            error.conform_password = "Conform password is required.";
        }
        if ((old_password?.trim() === new_password?.trim()) && (old_password?.trim() && new_password?.trim())) {
            error.new_password = "The old password and the new password cannot be the same.";
        }
        if (new_password?.trim() && !validateNewPassword(new_password?.trim())) {
            error.new_password = "New password must be at least 8 characters long and include uppercase letters, lowercase letters, numbers, and special characters.";
        }
        if ((new_password?.trim() && conform_password?.trim()) && new_password?.trim() !== conform_password?.trim()) {
            error.conform_password = "New password and confirm password do not match.";
        }
        setError(error);
        if (Object.keys(error).length <= 0) {
            try {
                const payload = {
                    ...resetPasswordData,
                    old_password: encryptData(resetPasswordData?.old_password, 'user_auth').toString(),
                    new_password: encryptData(resetPasswordData?.new_password, 'user_auth').toString(),
                }
                delete payload.conform_password
                const response = await services.login(Urls("RESETUSERPWUPSERT"), payload)
                if (response.status === 200) {
                    showSuccess('Sucess', response.body.message)
                    setTimeout(() => {
                        sessionStorage.clear();
                        window.location.pathname = "/sign-in"
                    }, 500);
                } else {
                    showError("Error", response.body.message);
                }
            } catch (err) {
                console.error("err", err)
                setError({ apiError: err?.response?.data?.errorMessage });
            }
        }
    }

    return useMemo(() => ({
        resetPasswordData,
        showPassword,
        setShowPassword,
        handleChange,
        HandleResetPassword,
        error
    }), [resetPasswordData, showPassword, setShowPassword, handleChange, HandleResetPassword, error]);
};
